import React from 'react';
import { browserHistory } from 'react-router';
import {
  inject,
  observer
} from 'mobx-react';
import AlarmList from '../../components/AlarmList/AlarmList';
import Button from '../../components/Button/Button';

import { setBackground } from '../../utils/style';

class AlarmListing extends React.Component {
  constructor(props) {
    super(props);

    this.addNewAlarm = this.addNewAlarm.bind(this);
    this.toggleAlarmActiveState = this.toggleAlarmActiveState.bind(this);
  }

  render() {
    return (
      <div className='mt-4 u-grow u-dir-column'>
        <AlarmList
          alarms={this.props.alarmStore.alarms}
          onActiveStateClick={this.toggleAlarmActiveState}
          onEditClick={function(alarmID) {
            browserHistory.push(`/alarms/${alarmID}`);
          }}
        />
        <div className='mb-4 mt-4 u-justify-center u-no-shrink'>
          <Button
            size='sm'
            type='outline'
            onClick={this.addNewAlarm}>
            + Add New Alarm
          </Button>
        </div>
      </div>
    );
  }

  componentWillMount() {
    setBackground('blue');
  }

  addNewAlarm() {
    browserHistory.push('/alarms/new')
  }

  toggleAlarmActiveState(toggledAlarm) {
    toggledAlarm.toggleActiveState();
  }
};

export default inject('alarmStore')(observer(AlarmListing));



// WEBPACK FOOTER //
// ./src/views/AlarmListing/index.js